module.exports = __webpack_public_path__ + "static/media/mob-app3.9207f7e3.jpg";